const EN = {
    title: 'Activity',
    table: {
        title: 'Activity list',
        columns: {
            id: 'ID GP',
            gpaccount: 'GP Account',
            date: 'Date',
            code: 'Code',
            type: 'Type',
            amount: 'Amount',
            client: 'Client',
            document: 'INE',
            lastFour: 'Last four',
            commerce: 'Commerce'
        },
        types: {
            authorization: 'Authorization',
            collection: 'Collection',
            partner_adjustment: 'Partner adjustment',
            rejection: 'Rejection',
            cancellation: 'Cancellation'
        },
        filter: {
            0: {
                title: 'By code',
                0: '501',
                1: '802'
            },
            1: {
                title: 'By type',
                0: 'Authorization',
                1: 'Rejection',
                2: 'Annulment'
            },
            2: {
                title: 'By commerce',
                0: 'Natura',
                1: 'Avon'
            }
        },
    }
};

export default EN;
